// extracted by mini-css-extract-plugin
module.exports = {"table_body":"Ranking_table_body__3jAaK","tbody":"Ranking_tbody__2RtWp","title":"Ranking_title__1NKbM","small":"Ranking_small__keXUX"};